import { globalApi as api } from '../../api';

// export const fetchCurrentMonth = async () => {
//     try {
//       const token = sessionStorage.getItem('token');
//       const response = await api.get('/get_currect_month',{
//             headers: {
//               'Authorization': `Bearer ${token}`,
//             }
//           }
//       );
//       return response.data;
//     } catch (error) {
//       throw error.response ? error.response.data.error : error.message;
//     }
//   };
export const fetchCurrentMonth = async () => {
  try {
    // Retrieve token and client_id from sessionStorage
    const token = sessionStorage.getItem('token');
    const client_id = sessionStorage.getItem('selectedClient');

    if (!client_id || client_id === 'null') {
      throw new Error('Client ID not found in session');
    }

    const response = await api.get(`/get_current_month/${client_id}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
      }
    });

    return response.data;
  } catch (error) {
    throw error.response ? error.response.data.error : error.message;
  }
};

export const CurrentMonthInput = async (currect_month) => {
  try {
    const client_ID = sessionStorage.getItem('selectedClient');
    const token = sessionStorage.getItem('token');
    const response = await api.put(`/update_currect_month`, currect_month, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    return {
      data: response.data,
      status: response.status,
    };

  } catch (error) {
    throw error.response
  ? (error.response.data.error || error.response.data.message)
  : error.message;
  }
};




export const CreateCurrentMonthInput = async (currect_month) => {
  try {
    const client_ID = sessionStorage.getItem('selectedClient');
    const token = sessionStorage.getItem('token');
    const response = await api.put(`/set_currect_month`, currect_month, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    return {
      data: response.data,
      status: response.status,
    };

  } catch (error) {
    throw error.response
  ? (error.response.data.error || error.response.data.message)
  : error.message;
  }
};
